/* Option rows for the PDP hero (sections/kkumi-product-hero.liquid, setting
   `option_rows`; PDP hero v3 handoff, phase 2).

   Every option group inside [data-kk-opt-rows] (the Simple Bundles app
   options from kkumi-sb-options and the native ones from
   product-variant-picker) becomes one row: thumbnail, label, chosen value,
   price, and a Change / Choose / Close button that opens its cards. One row
   is open at a time, and a row opening or closing above the one you tapped
   never moves it on screen.

   With data-advance (setting `option_rows_advance`, on by default) a pick
   closes the row and opens the next row below it that is still unset (no
   choice made). Rows above it, and rows that already have a choice
   (pre-selected or picked), never open by themselves; with none left the
   picked row stays open. Moving through the cards with the arrow
   keys (which fires change on every step) never advances.

   Options named in the product's `kkumi.start_blank_options` metafield
   arrive with data-kk-blank-start and no checked card (Liquid). Until the
   shopper picks one: the first such row is open, the price panel shows
   "from" the lowest price, Add to cart reads "Choose [option]" and opens the
   row instead of adding, and Buy it now does nothing. A link that names a
   variant (?variant=) counts as a choice, so nothing starts blank then.

   Dawn re-renders <variant-selects> on every native change. The rows are
   rebuilt on the new markup (MutationObserver), keeping which row is open,
   which groups the shopper has touched, and their pick in a blank option.

   An option with a "no" choice (No tweezers; data-kk-none from Liquid) gets
   an "Optional" pill, and while that choice is picked its row reads as that
   choice's name (No tweezers; or the option_rows_not_added setting), muted,
   with the empty dashed tile and Choose.

   Copy comes from the wrapper's data-* (section settings); the cards, radios
   and add-to-cart plumbing are the existing ones, untouched. */
(function () {
  // Quick view re-runs this file when it injects a hero: bind the new one.
  if (window.KKOptionRows) { window.KKOptionRows.init(); return; }

  var el;
  var uid = 0;

  function norm(s) { return String(s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function fill(tpl, label) { return String(tpl || '').split('[option]').join(label); }
  function toArray(list) { return Array.prototype.slice.call(list); }
  // Idempotent writes (MutationObserver feedback-loop rule, FRONTEND.md).
  function setText(node, text) { if (node && node.textContent !== text) node.textContent = text; }
  function setAttr(node, name, value) { if (node && node.getAttribute(name) !== value) node.setAttribute(name, value); }
  function looksLikePrice(text) { return /[$£€¥]|\d/.test(text); }

  // The element that scrolls this hero: the page, or the quick-view modal.
  function scroller(node) {
    for (var n = node.parentElement; n && n !== document.body; n = n.parentElement) {
      var oy = window.getComputedStyle(n).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && n.scrollHeight > n.clientHeight) return n;
    }
    return null;
  }

  function bind(wrap) {
    // KKEl (assets/kkumi-el.js) is loaded head-defer, ahead of this script.
    el = window.KKEl;
    if (!el || wrap.dataset.kkRowsBound === '1') return;
    wrap.dataset.kkRowsBound = '1';
    var hero = wrap.closest('product-info') || wrap.parentElement;
    var copy = wrap.dataset;
    var linked = /[?&]variant=/.test(window.location.search);
    var noneDefault = !!(hero && hero.hasAttribute && hero.hasAttribute('data-kk-none-default'));
    var blank = {};    // key -> true: this option started blank
    var touched = {};  // key -> true: the shopper has picked in it
    var chosen = {};   // key -> value picked in a blank native option
    var attempted = false;
    var open = null;
    var arrowAt = 0;   // last arrow-key press inside the rows (no advance)

    function live(fs) {
      // Dawn keeps the replaced <variant-selects> for 500ms, hidden.
      var vs = fs.closest('variant-selects');
      return !(vs && vs.style.display === 'none');
    }
    function groups() { return toArray(wrap.querySelectorAll('fieldset.var-block')).filter(live); }
    function radios(fs) { return toArray(fs.querySelectorAll('.var-options input[type="radio"]')); }
    function checkedIn(fs) { return fs.querySelector('.var-options input[type="radio"]:checked'); }
    function isApp(fs) { return fs.hasAttribute('data-kk-sb-entry'); }
    function labelOf(fs) {
      if (fs.hasAttribute('data-kk-sb-label')) return fs.getAttribute('data-kk-sb-label');
      var lg = fs.querySelector('legend');
      if (!lg) return '';
      var c = lg.cloneNode(true);
      toArray(c.querySelectorAll('.var-block__dot, .val, [data-selected-value]')).forEach(function (n) { n.remove(); });
      return c.textContent.replace(/\s+/g, ' ').trim();
    }
    function keyOf(fs) { return fs.getAttribute('data-kk-option-key') || norm(labelOf(fs)); }
    function missing() {
      return groups().filter(function (fs) { return blank[keyOf(fs)] && !checkedIn(fs); });
    }

    function enhance(fs) {
      var key = keyOf(fs);
      var single = radios(fs).length <= 1;
      // An optional option (has a "no" value) starts on "no", not blank,
      // while the hero's option_none_default is on: one rule, not two that
      // undo each other across Dawn's re-renders.
      var startsNone = noneDefault && fs.querySelector('input[type="radio"][data-kk-none]');
      if (fs.hasAttribute('data-kk-blank-start') && !linked && !single && !startsNone) blank[key] = true;
      if (blank[key] && !touched[key]) {
        radios(fs).forEach(function (r) { r.checked = false; r.removeAttribute('checked'); });
        setText(fs.querySelector('legend .val'), '');
      } else if (blank[key] && chosen[key] != null) {
        // Dawn re-rendered the natives: put the shopper's own pick back.
        var want = radios(fs).filter(function (r) { return r.value === chosen[key]; })[0];
        if (want && !want.checked) want.checked = true;
      }
      if (fs.getAttribute('data-kk-row') === '1') return;
      fs.setAttribute('data-kk-row', '1');

      var id = 'KkOptRow-' + (++uid);
      var panel = fs.querySelector('.var-options');
      var hd = el(single ? 'div' : 'button', 'kk-optrow__hd' + (single ? ' kk-optrow__hd--static' : ''));
      if (!single) {
        hd.type = 'button';
        hd.id = id + '-h';
        if (panel) {
          panel.id = id + '-p';
          panel.setAttribute('role', 'region');
          panel.setAttribute('aria-labelledby', hd.id);
          hd.setAttribute('aria-controls', panel.id);
        }
        hd.setAttribute('aria-expanded', 'false');
      }
      hd.appendChild(el('span', 'kk-optrow__thumb'));
      var t = el('span', 'kk-optrow__t');
      var lb = el('span', 'kk-optrow__lb', labelOf(fs));
      // An option with a "no" choice (No tweezers): the "Optional" pill.
      if (copy.optional && fs.querySelector('.var-options input[data-kk-none]')) {
        lb.appendChild(el('span', 'kk-optrow__opt', copy.optional));
      }
      t.appendChild(lb);
      var v = el('span', 'kk-optrow__v');
      v.appendChild(el('span', 'kk-optrow__val'));
      v.appendChild(el('span', 'kk-optrow__sub'));
      v.appendChild(el('span', 'kk-optrow__pre'));
      t.appendChild(v);
      hd.appendChild(t);
      hd.appendChild(el('span', 'kk-optrow__price'));
      if (!single) {
        var go = el('span', 'kk-optrow__go');
        go.appendChild(el('span', 'kk-optrow__go-t'));
        var chev = el('span', 'kk-optrow__chev');
        chev.setAttribute('aria-hidden', 'true');
        go.appendChild(chev);
        hd.appendChild(go);
      }
      var err = el('p', 'kk-optrow__err');
      err.setAttribute('role', 'alert');
      err.hidden = true;
      var lg = fs.querySelector('legend');
      var ref = lg ? lg.nextSibling : fs.firstChild;
      fs.insertBefore(hd, ref);
      fs.insertBefore(err, hd.nextSibling);
    }

    function paint(fs) {
      var hd = fs.querySelector('.kk-optrow__hd');
      if (!hd) return;
      var key = keyOf(fs);
      var label = labelOf(fs);
      var button = hd.tagName === 'BUTTON';
      var isOpen = button && open === key;
      if (fs.classList.contains('is-open') !== isOpen) fs.classList.toggle('is-open', isOpen);
      if (button) setAttr(hd, 'aria-expanded', isOpen ? 'true' : 'false');

      var r = checkedIn(fs);
      // A "no" choice (No tweezers) reads as nothing added: its name muted,
      // no price, no "pre-selected", and Choose rather than Change.
      var none = !!(r && r.hasAttribute('data-kk-none'));
      var card = r && r.closest('.var-option');
      var title = card && card.querySelector('.var-option__title');
      var subEl = card && card.querySelector('.var-option__sub');
      var sub = subEl ? subEl.textContent.replace(/\s+/g, ' ').trim() : '';

      // Thumbnail: the chosen card's own, a dashed tile while a photo option
      // has nothing chosen, nothing for text-only options.
      var slot = hd.querySelector('.kk-optrow__thumb');
      var hasThumbs = !!fs.querySelector('.var-options .var-option__thumb');
      var sig = r ? 'v:' + r.value : (hasThumbs ? 'empty' : 'none');
      if (slot.getAttribute('data-sig') !== sig) {
        slot.setAttribute('data-sig', sig);
        while (slot.firstChild) slot.removeChild(slot.firstChild);
        var src = card && card.querySelector('.var-option__thumb');
        if (src) slot.appendChild(src.cloneNode(true));
        slot.classList.toggle('kk-optrow__thumb--empty', !src && hasThumbs);
        slot.hidden = !src && !hasThumbs;
      }

      var val = hd.querySelector('.kk-optrow__val');
      var shown = title && !none;
      var titleText = title ? title.textContent.replace(/\s+/g, ' ').trim() : '';
      // A "no" choice reads as its own name (No tweezers), muted, unless the
      // option_rows_not_added setting gives one wording for all of them.
      setText(val, none ? (copy.notAdded || titleText) : titleText || fill(copy.prompt, label));
      if (val.classList.contains('is-empty') === !!shown) val.classList.toggle('is-empty', !shown);
      setText(hd.querySelector('.kk-optrow__sub'), sub && !none && !looksLikePrice(sub) ? sub : '');
      setText(hd.querySelector('.kk-optrow__price'), sub && !none && looksLikePrice(sub) ? sub : '');
      var pre = !!card && !none && !linked && !touched[key] && !blank[key] && button;
      setText(hd.querySelector('.kk-optrow__pre'), pre ? (copy.preselected || '') : '');
      if (button) {
        setText(hd.querySelector('.kk-optrow__go-t'), isOpen ? copy.close : (card && !none ? copy.change : copy.choose));
      }

      // The missing-choice error after an add attempt (the app options carry
      // their own message and aria-invalid from kkumi-sb-options).
      var err = fs.querySelector('.kk-optrow__err');
      var showErr = attempted && !card && blank[key] && !isApp(fs);
      setText(err, showErr ? fill(copy.error, label) : '');
      if (err.hidden === showErr) err.hidden = !showErr;
      if (!isApp(fs)) {
        if (showErr) setAttr(fs, 'aria-invalid', 'true');
        else if (fs.hasAttribute('aria-invalid')) fs.removeAttribute('aria-invalid');
      }
    }

    function syncMissing() {
      var m = missing();
      var on = m.length > 0;
      if (hero.classList.contains('kk-choice-missing') !== on) hero.classList.toggle('kk-choice-missing', on);
      setText(hero.querySelector('[data-kk-atc-choose]'), on ? fill(copy.prompt, labelOf(m[0])) : '');
      // Under the "from" price: which option to choose to see the price.
      var hint = hero.querySelector('[data-kk-price-from-hint]');
      if (hint) setText(hint, on ? fill(hint.dataset.format, labelOf(m[0]).toLowerCase()) : '');
      var buy = hero.querySelector('[data-kk-buynow]');
      if (buy) {
        if (on) {
          if (buy.getAttribute('aria-disabled') !== 'true') {
            buy.setAttribute('aria-disabled', 'true');
            buy.dataset.kkRowsDisabled = '1';
          }
        } else if (buy.dataset.kkRowsDisabled) {
          delete buy.dataset.kkRowsDisabled;
          // Only undo what this script did: the hero sets it for sold out.
          if (buy.hasAttribute('href')) buy.removeAttribute('aria-disabled');
        }
      }
      if (!on) attempted = false;
    }

    function paintAll() { groups().forEach(paint); syncMissing(); }

    function scrollToRow(hd) {
      var box = scroller(hd);
      var offset = (parseInt(window.getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0) + 16;
      var smooth = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      var top = hd.getBoundingClientRect().top;
      if (box) {
        box.scrollTo({ top: box.scrollTop + top - box.getBoundingClientRect().top - 12, behavior: smooth ? 'smooth' : 'auto' });
      } else {
        window.scrollTo({ top: window.pageYOffset + top - offset, behavior: smooth ? 'smooth' : 'auto' });
      }
    }

    // Open a row and put focus on its cards (an add was stopped for it).
    function reveal(fs) {
      attempted = true;
      open = keyOf(fs);
      paintAll();
      scrollToRow(fs.querySelector('.kk-optrow__hd') || fs);
      var target = fs.querySelector('.var-options input[type="radio"]:checked') ||
        fs.querySelector('.var-options input[type="radio"]:not(:disabled)');
      if (target) target.focus({ preventScroll: true });
    }

    // Header: open / close, keeping the tapped header where it was on screen.
    wrap.addEventListener('click', function (e) {
      var hd = e.target.closest && e.target.closest('button.kk-optrow__hd');
      if (!hd || !wrap.contains(hd)) return;
      e.preventDefault();
      var fs = hd.closest('fieldset');
      var key = keyOf(fs);
      var before = hd.getBoundingClientRect().top;
      open = open === key ? null : key;
      paintAll();
      var delta = hd.getBoundingClientRect().top - before;
      if (Math.abs(delta) > 1) {
        var box = scroller(hd);
        if (box) box.scrollTop += delta; else window.scrollBy(0, delta);
      }
    });

    // The row to open after a pick in `fs`: the first one below it that is
    // still unset. Never one above it, never one that already has a choice.
    function nextAfter(fs) {
      var all = groups().filter(function (g) { return g.querySelector('button.kk-optrow__hd'); });
      var i = all.indexOf(fs);
      if (i < 0) return null;
      return all.slice(i + 1).filter(function (g) { return !checkedIn(g); })[0] || null;
    }

    wrap.addEventListener('keydown', function (e) {
      if (/^Arrow/.test(e.key)) arrowAt = Date.now();
    });

    // A pick: remember it, then advance (or keep the row open), keeping the
    // picked row's header where it was on screen as its cards fold away.
    wrap.addEventListener('change', function (e) {
      var r = e.target;
      if (!r || r.type !== 'radio') return;
      var fs = r.closest('fieldset.var-block');
      if (!fs || !wrap.contains(fs)) return;
      var key = keyOf(fs);
      // The hero's switch to an optional option's "no" value on load
      // (option_none_default) isn't the shopper's pick.
      if (r.hasAttribute('data-kk-auto-pick')) { paintAll(); return; }
      touched[key] = true;
      if (blank[key]) chosen[key] = r.value;
      var hd = fs.querySelector('.kk-optrow__hd');
      var advance = copy.advance != null && open === key && Date.now() - arrowAt > 400;
      if (!advance || !hd) { paintAll(); return; }
      // Nothing below still to choose (the rest already have a value,
      // pre-selected included): the picked row stays open (owner, 2026-10-06).
      var next = nextAfter(fs);
      if (!next) { paintAll(); return; }
      var before = hd.getBoundingClientRect().top;
      open = keyOf(next);
      paintAll();
      var delta = hd.getBoundingClientRect().top - before;
      if (Math.abs(delta) > 1) {
        var box = scroller(hd);
        if (box) box.scrollTop += delta; else window.scrollBy(0, delta);
      }
    });

    // The contents card's Change / Choose (kkumi-pdp-contents.js): open the
    // row, no error state. That script scrolls and moves focus itself.
    wrap.addEventListener('kk:open-option', function (e) {
      var fs = e.target.closest && e.target.closest('fieldset.var-block');
      if (!fs) return;
      open = keyOf(fs);
      paintAll();
    });

    // kkumi-sb-options stopped an add for one of its options: open that row
    // before it moves focus there.
    wrap.addEventListener('kk:reveal-option', function (e) {
      var fs = e.target.closest && e.target.closest('fieldset.var-block');
      if (!fs) return;
      attempted = true;
      open = keyOf(fs);
      paintAll();
    });

    // Add to cart while an option is still blank: open it instead. On WINDOW
    // in the capture phase, ahead of global.js's document-level add handler
    // (the same reason kkumi-sb-options sits there). App options are left to
    // kkumi-sb-options' own check, which reveals the row itself.
    window.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !hero.contains(f)) return;
      var m = missing();
      if (!m.length || isApp(m[0])) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      reveal(m[0]);
    }, true);

    // Buy it now while an option is still blank: same.
    hero.addEventListener('click', function (e) {
      var buy = e.target.closest && e.target.closest('[data-kk-buynow]');
      if (!buy) return;
      var m = missing();
      if (!m.length) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      reveal(m[0]);
    }, true);

    // Dawn's re-render of <variant-selects>: rebuild the new rows. Only acts
    // when a fieldset without a row appears, so its own writes can't loop.
    new MutationObserver(function () {
      var fresh = toArray(wrap.querySelectorAll('fieldset.var-block:not([data-kk-row])'));
      if (!fresh.length) return;
      fresh.forEach(enhance);
      paintAll();
    }).observe(wrap, { childList: true, subtree: true });

    // The hero re-applies Buy it now on every variant change; re-assert after.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(syncMissing, 0); });
    }

    groups().forEach(enhance);
    var first = groups().filter(function (fs) { return blank[keyOf(fs)] && !checkedIn(fs); })[0];
    if (first) open = keyOf(first);
    paintAll();
    wrap.classList.add('is-ready');
  }

  function init() {
    toArray(document.querySelectorAll('[data-kk-opt-rows]')).forEach(bind);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Theme editor re-renders the section in place.
  document.addEventListener('shopify:section:load', init);
  window.KKOptionRows = { init: init };
})();
